import moment from "moment"

type Expiry<R> = {
    __value: R;
    __expiry: string;
}

const dateFormat = "YYYY-MM-DD HH:mm:ss";

class Storage {
    private readonly store: globalThis.Storage;

    constructor(type: "session" | "local") {
        this.store = type === "session" ? sessionStorage : localStorage;
        this.getItem = this.getItem.bind(this);
        this.setItem = this.setItem.bind(this);
        this.removeItem = this.removeItem.bind(this)
    }

    getItem<R>(key: string) {
        const json = this.store.getItem(key);
        if (json === null) return null;
        const {__value, __expiry} = JSON.parse(json) as Expiry<R>

        // if expiry is after now, return value. Otherwise, return null
        return moment.utc(__expiry, dateFormat).isAfter(moment.utc()) ? __value : null;
    }

    setItem<R>(key: string, value: R, hoursValid: number = 24) {
        const payload: Expiry<R> = {
            __value: value,
            __expiry: moment.utc()
                .add(hoursValid, "hours")
                .format(dateFormat)
        };
        this.store.setItem(key, JSON.stringify(payload));
    }

    removeItem(key: string) {
        console.log(`Remove ${key} from local storage`);
        this.store.removeItem(key)
    }
}

export const localStore = new Storage("local")
export const sessStore = new Storage("session")